/**
 * A global namespace for `move` event.
 */
const moveEvent = 'move';
export default moveEvent;
